export default "__VITE_ASSET__BHyzU_d2__"